import React from 'react';
import Goal from '../../../models/Goal';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, darken } from '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { personTypeToDescription } from '../../Client/Profile';
import { useThemeContext } from '../../../theme/ThemeContext';
import { formattedCurrency } from '../../../utils/StringUtils';
import { GOAL_KIND_STANDARD, translateGoalKindDescription, translateStatusGoalDescription } from './GoalList';

export interface Row {
  data: Goal
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  adminInfo?: boolean;
  managerInfo?: boolean;
  onClickInfo?: (goal: Goal) => void;
  onChangePage?: (page: number) => void;
}

const Goals: React.FC<Props> = (props) => {
  const { t } = useTranslation(['goal', 'person'])
  const { theme } = useThemeContext();

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }
  return (
    <Paper style={{ borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px" }}>
      {!props.fromIn && <ISTableTitle title={t('title')} />}
      <Table style={{ whiteSpace: "nowrap", overflow: "hidden" }} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell align='center'>{t('from')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('to')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('personType')}</ISTableHeaderCell>
            <ISTableHeaderCell>Tipo de objetivo</ISTableHeaderCell>
            <ISTableHeaderCell>{t('byPersonTypeId')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('brandName')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('typeOfGoal')}</ISTableHeaderCell>
            <ISTableHeaderCell align='right'>{t('goal')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('minPriceListId')}</ISTableHeaderCell>
            <ISTableHeaderCell align='center'>{t('maxPriceListId')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('dataAdic')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('status')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('createdBy')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!props.loading && props.rows.map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{ cursor: 'pointer', backgroundColor: row.data.status !== 'ACTIVE' ? darken(theme.palette.action.hover, 0.1) : '' }}
              onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
              <TableCell align='center'>{moment(new Date(row.data.from!)).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</TableCell>
              <TableCell align='center'>{moment(new Date(row.data.to!)).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</TableCell>
              <TableCell>{t(personTypeToDescription(row.data.personType!), { ns: 'person' })}</TableCell>
              <TableCell>{translateGoalKindDescription(row.data.goalKind ?? GOAL_KIND_STANDARD)}</TableCell>
              <TableCell>{row.data.byPersonTypeId}</TableCell>
              <TableCell>{row.data.brandId ? row.data.brandId === 9999 ? t('others') : row.data.brandName : t('general')}</TableCell>
              <TableCell>{row.data.typeOfGoal}</TableCell>
              <TableCell align='right'>{formattedCurrency(row.data.goal)}</TableCell>
              <TableCell align='center'>{row.data.minPriceListId > 0 ? row.data.minPriceListId : t('noLimit')}</TableCell>
              <TableCell align='center'>{row.data.maxPriceListId > 0 && row.data.maxPriceListId < 9999 ? row.data.maxPriceListId : t('noLimit')}</TableCell>
              <TableCell>{row.data.dataAdic}</TableCell>
              <TableCell>{translateStatusGoalDescription(row.data.status)}</TableCell>
              <TableCell>{row.data.ownerName}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      {props.loading &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default Goals